/* eslint-disable @typescript-eslint/no-explicit-any */
import { Divider } from "@mui/material";
import Styles from "./paymentDetailCard.module.scss";
import cn from "clsx";
import { useStores } from "@/app/csr-src/models";
import { observer } from "mobx-react-lite";
import MainOrderSummary from "./mainOrderSummary/mainOrderSummary";
import MinimumPaymentFlag from "./minimumPaymentFlag/MinimumPaymentFlag";
import { EXPOSURE_RECORD } from "@/tracks/25281";
import { useTranslation } from "react-i18next";

interface PaymentDetailCardProps {
  className?: string;
  children: React.ReactNode;
}

const PaymentDetailCard = observer((props: PaymentDetailCardProps) => {
  const { checkoutStore } = useStores();
  const { t } = useTranslation();
  // ====== Constants ===========  //
  const DIVIDER_COLOR = "#F0F1F2";
  // ===============================  //

  return (
    <div className={cn(Styles.paymentDetailCardBox, props.className)}
      exptag={"exp|" + EXPOSURE_RECORD.SettleAccounts_OrderNew_DetailExpo}
      data-exptag-config='{"useClick": false, "stay_duration": 0, "repeated":false, "area_rate": 0.01}'
      data-exptag-json-param={JSON.stringify(checkoutStore.paymentTrackInfo)}
    >
      <div className={Styles.title}>{t("checkout.paymentDetail.title")}</div>
      <MainOrderSummary
        orderDetails={checkoutStore.paymentDetail}
        currencySymbol={checkoutStore.currencySymbol}
      />
      <div
        exptag={"exp|" + EXPOSURE_RECORD.SettleAccounts_OrderNew_ZeroTipExpo}
        data-exptag-config='{"useClick": false, "stay_duration": 0, "repeated":false, "area_rate": 0.01}'
        data-exptag-json-param="">
        {(checkoutStore.zeroInfo as any)?.isZeroOrder && (
          <MinimumPaymentFlag text={(checkoutStore.zeroInfo as any)?.zeroOrderText} />
        )}
      </div>
      <Divider style={{ color: DIVIDER_COLOR, marginTop: "16px" }} />

      {/* <div className={Styles.paymentDetailBox}>*/}
      {/*  {checkoutStore.paymentDetail.map((item: any, index) => {*/}
      {/*    return (*/}
      {/*      <div key={index}>*/}
      {/*        <div*/}
      {/*          className={cn(Styles.paymentDetailItem, Styles[item.className], {*/}
      {/*            [Styles.paymentTotalBox]: item.floorType === AMOUNT_FLOOR_TYPE.TOTAL,*/}
      {/*            [Styles.discountBox]:*/}
      {/*              item.floorType === AMOUNT_FLOOR_TYPE.PROMOTIONS ||*/}
      {/*              item.floorType === AMOUNT_FLOOR_TYPE.COUPONS ||*/}
      {/*              item.floorType === AMOUNT_FLOOR_TYPE.DISCOUNT,*/}
      {/*          })}*/}
      {/*          onClick={() => {*/}
      {/*            if (item.floorType === AMOUNT_FLOOR_TYPE.PROMOTIONS) {*/}
      {/*              setPromotionsShow(!promotionsShow);*/}
      {/*              return; // 阻止点击事件冒泡*/}
      {/*            }*/}

      {/*            if (item.floorType === AMOUNT_FLOOR_TYPE.COUPONS) {*/}
      {/*              setcouponsShow(!couponsShow);*/}
      {/*              return; // 阻止点击事件冒泡*/}
      {/*            }*/}
      {/*            return; // 阻止点击事件冒泡*/}
      {/*          }}*/}
      {/*        >*/}
      {/*          {item.label === "Shipping fee" ? (*/}
      {/*            <>*/}
      {/*              <div className={Styles.shippingFeeContainer}>*/}
      {/*                <span className={Styles.main}>{item.label}</span>*/}
      {/*                {item.iconFlag && (*/}
      {/*                  <Tooltip*/}
      {/*                    title={item.iconText}*/}
      {/*                    arrow*/}
      {/*                    placement="top"*/}
      {/*                    slotProps={{*/}
      {/*                      tooltip: {*/}
      {/*                        sx: {*/}
      {/*                          backgroundColor: BLACK_COLOR,*/}
      {/*                        },*/}
      {/*                      },*/}
      {/*                      arrow: {*/}
      {/*                        sx: {*/}
      {/*                          color: BLACK_COLOR,*/}
      {/*                        },*/}
      {/*                      },*/}
      {/*                    }}*/}
      {/*                  >*/}
      {/*                    <div className={Styles.icon}>*/}
      {/*                      <InfoIcon />*/}
      {/*                    </div>*/}
      {/*                  </Tooltip>*/}
      {/*                )}*/}
      {/*                {item.subLabel && <span className={Styles.sub}>{item.subLabel}</span>}*/}
      {/*              </div>*/}
      {/*            </>*/}
      {/*          ) : (*/}
      {/*            <div className={Styles.label}>*/}
      {/*              <span*/}
      {/*                className={cn(Styles.main, {*/}
      {/*                  [Styles.orderTotalMain]: item.floorType === AMOUNT_FLOOR_TYPE.TOTAL,*/}
      {/*                })}*/}
      {/*              >*/}
      {/*                {item.label}*/}
      {/*              </span>*/}
      {/*              {item.subLabel && (*/}
      {/*                <span*/}
      {/*                  className={cn(Styles.sub, {*/}
      {/*                    [Styles.orderTotalsubLabel]: item.floorType === AMOUNT_FLOOR_TYPE.TOTAL,*/}
      {/*                  })}*/}
      {/*                >*/}
      {/*                  {item.subLabel}*/}
      {/*                </span>*/}
      {/*              )}*/}
      {/*            </div>*/}
      {/*          )}*/}
      {/*          /!* pricing *!/*/}
      {/*          <div className={Styles.price}>*/}
      {/*            /!* Sidebar save *!/*/}
      {/*            {item.saved && item.saved.amount ? (*/}
      {/*              <div className={Styles.savedItem}>*/}
      {/*                <span className={Styles.savedLabel}>{item.saved.label}</span>*/}
      {/*                <JDIPrice*/}
      {/*                  symbol={checkoutStore.currencySymbol}*/}
      {/*                  price={item.saved.amount}*/}
      {/*                  uiType={2}*/}
      {/*                  containerStyle={{*/}
      {/*                    fontSize: item.saved.fontSize,*/}
      {/*                    lineHeight: item.saved.height,*/}
      {/*                    height: item.saved.height,*/}
      {/*                    color: item.saved.color,*/}
      {/*                  }}*/}
      {/*                />*/}
      {/*              </div>*/}
      {/*            ) : null}*/}
      {/*            /!* Show Prices  *!/*/}
      {/*            {item.floorType === AMOUNT_FLOOR_TYPE.PROMOTIONS ||*/}
      {/*            item.floorType === AMOUNT_FLOOR_TYPE.DISCOUNT ||*/}
      {/*            item.floorType === AMOUNT_FLOOR_TYPE.COUPONS ? (*/}
      {/*              <>*/}
      {/*                -*/}
      {/*                <JDIPrice*/}
      {/*                  symbol={checkoutStore.currencySymbol}*/}
      {/*                  price={item.amount}*/}
      {/*                  uiType={2}*/}
      {/*                  containerStyle={{*/}
      {/*                    fontSize: item.fontSize,*/}
      {/*                    lineHeight: item.height,*/}
      {/*                    height: item.height,*/}
      {/*                    color: item.color,*/}
      {/*                  }}*/}
      {/*                />*/}
      {/*                {item.showIcon && (*/}
      {/*                  <ArrowDown*/}
      {/*                    className={cn(Styles.arrowBox, {*/}
      {/*                      [Styles.up]:*/}
      {/*                        (item.floorType === AMOUNT_FLOOR_TYPE.PROMOTIONS && promotionsShow) ||*/}
      {/*                        (item.floorType === AMOUNT_FLOOR_TYPE.COUPONS && couponsShow),*/}
      {/*                    })}*/}
      {/*                  />*/}
      {/*                )}*/}
      {/*              </>*/}
      {/*            ) : item.label === "Shipping fee" &&*/}
      {/*              (item.discountedShippingFee !== "0" || item.amountShow === FREE_LABEL) ? (*/}
      {/*              <>*/}
      {/*                <JDIPrice*/}
      {/*                  symbol={checkoutStore.currencySymbol}*/}
      {/*                  price={item && item.originalAmount}*/}
      {/*                  uiType={2}*/}
      {/*                  containerStyle={{*/}
      {/*                    fontSize: item.fontSize,*/}
      {/*                    lineHeight: item.height,*/}
      {/*                    height: item.height,*/}
      {/*                    color: "#888B94",*/}
      {/*                    textDecoration: "line-through",*/}
      {/*                    marginRight: "8px",*/}
      {/*                    display: item && parseFloat(item.originalAmount) !== 0 ? "block" : "none",*/}
      {/*                  }}*/}
      {/*                />*/}
      {/*                <span className={Styles.tag}>*/}
      {/*                  {item.amountShow === FREE_LABEL ? FREE_LABEL : item.amountShow}*/}
      {/*                </span>*/}
      {/*              </>*/}
      {/*            ) : (*/}
      {/*              <JDIPrice*/}
      {/*                symbol={checkoutStore.currencySymbol}*/}
      {/*                price={item.amount}*/}
      {/*                uiType={2}*/}
      {/*                containerStyle={{*/}
      {/*                  fontSize: item.fontSize,*/}
      {/*                  lineHeight: item.height,*/}
      {/*                  height: item.height,*/}
      {/*                  color: item.color,*/}
      {/*                  marginLeft: item.marginLeft && item.marginLeft,*/}
      {/*                }}*/}
      {/*              />*/}
      {/*            )}*/}
      {/*          </div>*/}
      {/*        </div>*/}

      {/*        {item.amountDetail?.length &&*/}
      {/*          ((item.floorType === AMOUNT_FLOOR_TYPE.PROMOTIONS && promotionsShow) ||*/}
      {/*            (item.floorType === AMOUNT_FLOOR_TYPE.COUPONS && couponsShow)) && (*/}
      {/*            <div className={Styles.detailBox}>*/}
      {/*              {item.amountDetail.map((item: any, index: number) => {*/}
      {/*                return (*/}
      {/*                  <div className={Styles.detailItem} key={index}>*/}
      {/*                    <div className={Styles.label}>{item.label}</div>*/}
      {/*                    <div className={Styles.price}>*/}
      {/*                      -*/}
      {/*                      <JDIPrice*/}
      {/*                        symbol={checkoutStore.currencySymbol}*/}
      {/*                        price={item.amount}*/}
      {/*                        uiType={2}*/}
      {/*                        containerStyle={{*/}
      {/*                          fontSize: "14px",*/}
      {/*                          lineHeight: "18px",*/}
      {/*                          height: "18px",*/}
      {/*                          color: "#FF0F23",*/}
      {/*                        }}*/}
      {/*                      />*/}
      {/*                    </div>*/}
      {/*                  </div>*/}
      {/*                );*/}
      {/*              })}*/}
      {/*            </div>*/}
      {/*          )}*/}
      {/*        {(checkoutStore.zeroInfo as any)?.isZeroOrder && item.isShowZeroFlag && (*/}
      {/*          <Alert*/}
      {/*            icon={<WarningIcon fontSize="#FBB731" />}*/}
      {/*            severity="warning"*/}
      {/*            sx={{*/}
      {/*              ".MuiPaper-root-MuiAlert-root": {*/}
      {/*                color: "#C99227",*/}
      {/*                backgroundColor: "#FFF8EA",*/}
      {/*                border: "1px solid #FDE2AD",*/}
      {/*                borderRadius: "8px",*/}
      {/*              },*/}
      {/*            }}*/}
      {/*          >*/}
      {/*            {(checkoutStore.zeroInfo as any)?.zeroOrderText}*/}
      {/*          </Alert>*/}
      {/*        )}*/}
      {/*        {item.divider && <Divider style={{ color: DIVIDER_COLOR }} />}*/}
      {/*      </div>*/}
      {/*    );*/}
      {/*  })}*/}
      {/*  <Divider style={{ color: DIVIDER_COLOR, marginTop: "16px" }} />*/}
      {/* </div>*/}
      {props.children}
    </div>
  );
});

export default PaymentDetailCard;
